/* eslint eqeqeq: "off" */
import { makeStyles } from "@material-ui/core/styles";
import { Formik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useCampContext } from "./CampDataContext";

const prepareFilter = (values) => {
  const {
    idFilter,
    programTypeFilter,
    campTypeFilter,
    dateFilter,
    deliveryTypeFilter,
    activeFilter,
    courseFilter,
  } = values;
  const filter = {};
  // Filter by program
  filter.id = idFilter !== "" ? idFilter : "";
  filter.program_name = programTypeFilter !== "" ? programTypeFilter : "";
  filter.camp_type_id = campTypeFilter !== "" ? campTypeFilter : "";
  filter.date = dateFilter !== "" ? dateFilter : "";
  filter.delivery_type_value =
    deliveryTypeFilter !== "" ? deliveryTypeFilter : "";
  filter.active_value = activeFilter !== "" ? activeFilter : "";
  filter.courses = courseFilter !== "" ? courseFilter : "";

  // Filter by all fields
  //   filter.date = searchText;
  //   if (searchText) {
  //     filter.start_time = searchText;
  //     filter.end_time = searchText;
  //     filter.instructor = searchText;
  //   }

  return filter;
};

export function CampFilter({ filterData, origData, loading }) {
  const formRef = useRef();
  const DROPDOWN_TYPE = useCampContext().TYPES;
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const context = useCampContext();
  const applyFilter = (values) => {
    //apply filter here
    filterData(prepareFilter(values));
  };

  const useStyles = makeStyles({
    btnCircleSm: {
      width: "30px",
      height: "30px",
      padding: "0px 7px",
      margin: "2px 1px 1px 1px",
      borderRadius: "15px",
      fontSize: "4px",
      textAlign: "center",
    },
  });
  const classes = useStyles();

  useEffect(() => {
    const initialValues = {
      idFilter: "",
      programTypeFilter: "",
      dateFilter: moment().format("yyyy-MM-DD"),
      campTypeFilter: "",
      deliveryTypeFilter: "",
      activeFilter: "Active",
      courseFilter: "",
    };
    applyFilter(initialValues);
    // eslint-disable-next-line
  }, [origData]);

  //fetching classes for a branch
  useEffect(() => {
    formRef.current.click();
  }, [context.refetch, loading]);

  return (
    <>
      <Formik
        initialValues={{
          idFilter: "",
          programTypeFilter: "",
          dateFilter: moment().format("yyyy-MM-DD"),
          campTypeFilter: "",
          deliveryTypeFilter: "",
          activeFilter: "Active",
          courseFilter: "",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Active"
                  name="activeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("activeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.activeFilter}
                >
                  <option value="">All</option>

                  {DROPDOWN_TYPE.ACTIVE &&
                    DROPDOWN_TYPE.ACTIVE.map((a) => (
                      <option key={a.id} value={a.value}>
                        {a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Status
                </small>
              </div>
              <div className="col-lg-3">
                <input
                  type="date"
                  className={`form-control`}
                  placeholder="Filter by Date"
                  name="dateFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("dateFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.dateFilter}
                />
                <small className="form-text text-muted">
                  <b>Filter</b> by Date
                </small>
              </div>

              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Camp Type"
                  name="campTypeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("campTypeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.campTypeFilter}
                >
                  <option value="">All</option>
                  {DROPDOWN_TYPE.BATCH_TYPE &&
                    DROPDOWN_TYPE.BATCH_TYPE.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Camp Type
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Program Type"
                  name="programTypeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("programTypeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.programTypeFilter}
                >
                  <option value="">All</option>
                  {DROPDOWN_TYPE.PROGRAM_TYPE &&
                    DROPDOWN_TYPE.PROGRAM_TYPE.map((a) => (
                      <option key={a.id} value={a.value}>
                        {a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Program Type
                </small>
              </div>
              <div className="col-lg-2">
                <Select
                  isMulti
                  name="courseFilter"
                  options={DROPDOWN_TYPE.SELECT_COURSE_OPTIONS}
                  onChange={(e) => {
                    let streams = e.map((c) => {
                      return c.value;
                    });
                    if (streams.length == 0) {
                      streams = "";
                    }
                    setFieldValue("courseFilter", streams);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Filter</b> by Stream Name
                </small>
              </div>
              <button
                type={"submit"}
                ref={formRef}
                style={{ display: "none" }}
                onClick={handleSubmit}
              />

              {/* <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search"
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue("searchText", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> in all fields
                </small>
              </div> */}
              <button
                className={`btn btn-sm btn-circle btn-light ${classes.btnCircleSm}`}
                onClick={(e) => setShowMoreFilters(!showMoreFilters)}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <i
                    className={`fa text-${
                      showMoreFilters ? `secondary fa-minus` : `primary fa-plus`
                    }`}
                  ></i>
                </span>
              </button>
            </div>
            {showMoreFilters && (
              <div className="form-group row">
                <div className="col-lg-2">
                  <input
                    className="form-control"
                    placeholder="ID"
                    name="idFilter"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("idFilter", e.target.value);
                      handleSubmit();
                    }}
                    value={values.idFilter}
                  ></input>
                  <small className="form-text text-muted">
                    <b>Filter</b> by ID
                  </small>
                </div>
                <div className="col-lg-2">
                  <select
                    className="form-control"
                    placeholder="Filter by Delivery Type"
                    name="deliveryTypeFilter"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setFieldValue("deliveryTypeFilter", e.target.value);
                      handleSubmit();
                    }}
                    value={values.deliveryTypeFilter}
                  >
                    <option value="">All</option>
                    {DROPDOWN_TYPE.DELIVERY_TYPE &&
                      DROPDOWN_TYPE.DELIVERY_TYPE.map((a) => (
                        <option key={a.id} value={a.value}>
                          {a.value}
                        </option>
                      ))}
                  </select>
                  <small className="form-text text-muted">
                    <b>Filter</b> by Delivery Type
                  </small>
                </div>
              </div>
            )}
          </form>
        )}
      </Formik>
    </>
  );
}
